{
  "modal": {
    "close": "Închide"
  },
  "upload": {
    "title": "Încărcări",
    "doneCount": "{done}/{total} gata",
    "inProgress": "{active} în curs",
    "clearFinished": "Șterge finalizate",
    "cancel": "Anulează",
    "retry": "Reîncearcă",
    "status": {
      "queued": "În coadă",
      "preparing": "Se citește…",
      "done": "Gata",
      "cancelled": "Anulat",
      "failed": "Eșuat"
    }
  },
  "tagPicker": {
    "addTag": "Adaugă etichetă…",
    "create": "Creează",
    "noMatches": "Nicio etichetă potrivită",
    "remove": "Elimină"
  },
  "currency": {
    "label": "Monedă",
    "add": "Adaugă o monedă",
    "addSave": "Adaugă",
    "code": "Cod",
    "name": "Nume",
    "namePlaceholder": "ex. Euro",
    "invalid": "Introdu un cod valutar din 3 litere (ex. EUR)."
  },
  "photoUpload": {
    "uploading": "Se încarcă…",
    "change": "Schimbă fotografia",
    "upload": "Încarcă o fotografie",
    "hint": "JPEG, PNG, WebP sau GIF · până la 5 MB",
    "badType": "Folosește o imagine JPEG, PNG, WebP sau GIF",
    "tooLarge": "Imagine prea mare (maximum 5 MB)",
    "failed": "Încărcarea a eșuat"
  },
  "editor": {
    "textStyle": "Stil text",
    "bold": "Aldin",
    "italic": "Cursiv",
    "bulletList": "Listă cu puncte",
    "link": "Link",
    "inlineCode": "Cod inline",
    "linkPrompt": "Adresă link",
    "normalText": "Text normal",
    "heading1": "Titlu 1",
    "heading2": "Titlu 2",
    "heading3": "Titlu 3"
  },
  "album": {
    "allAlbums": "Toate albumele",
    "edit": "Editează",
    "delete": "Șterge",
    "deleteAlbum": "Șterge albumul",
    "setAsCover": "Setează ca copertă",
    "download": "Descarcă",
    "remove": "Elimină",
    "openFull": "Deschide originalul",
    "close": "Închide",
    "approve": "Aprobă",
    "reject": "Respinge",
    "confirm": "Confirmă",
    "select": "Selectează",
    "clearSelection": "Anulează selecția",
    "selected": "{count} selectate",
    "selectAll": "Selectează tot ({count})",
    "pending": "În așteptare",
    "cover": "Copertă",
    "tags": "Etichete",
    "tagPlaceholder": "Caută sau creează o etichetă…",
    "itemOne": "element",
    "itemOther": "elemente",
    "coverUpdated": "Coperta albumului a fost actualizată",
    "approved": "Aprobat",
    "fetchFailed": "Nu s-a putut prelua {name}",
    "downloaded": "Au fost descărcate {count} {items} ca {name}",
    "downloadFailed": "Descărcarea a eșuat: {message}",
    "uploaded": "{count} {items} încărcate{failed}",
    "submitted": "{count} {items} trimise spre aprobare{failed}",
    "failedSuffix": ", {count} eșuate",
    "skippedUnsupported": "„{name}” a fost omis — tip neacceptat",
    "deleteItemsHeading": "Șterge elementele",
    "deleteItemsMessage": "Ștergi definitiv {count} {items}? Această acțiune nu poate fi anulată.",
    "deleteItemHeading": "Șterge elementul",
    "deleteItemMessage": "Ștergi „{name}”? Această acțiune nu poate fi anulată.",
    "rejectHeading": "Respinge trimiterea",
    "rejectMessage": "Respingi „{name}”? Va fi șters, iar elevul va fi notificat. Poți adăuga un motiv mai jos.",
    "deleteAlbumHeading": "Șterge albumul",
    "deleteAlbumMessage": "Ștergi albumul „{name}” și toate fișierele media? Această acțiune nu poate fi anulată.",
    "uploadSubmit": "Trage fotografii sau videoclipuri pentru a le trimite spre aprobare",
    "uploadDrop": "Trage fotografii sau videoclipuri aici sau dă clic pentru a încărca",
    "preparingZip": "Se pregătește ZIP — {done}/{total}",
    "emptyHeading": "Album gol",
    "emptySubmit": "Trimite primele fotografii sau videoclipuri.",
    "emptyUpload": "Încarcă primele fotografii sau videoclipuri.",
    "emptyNothing": "Încă nu există nimic aici.",
    "awaitingApproval": "în așteptarea aprobării",
    "taken": "Realizat {date}",
    "reasonPlaceholder": "Motiv (opțional, partajat cu elevul)"
  }
}
